import React, { Component } from 'react';

// Material UI Imports
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import pink from "@material-ui/core/colors/pink";
import orange from "@material-ui/core/colors/orange";
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'

// Material Icons Imports
import IconSocialPeople from '@material-ui/icons/People';
import IconActionGroupW from '@material-ui/icons/GroupWork';
import IconActionQuestion from '@material-ui/icons/QuestionAnswer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// Components Imports
import Question from './Question';
import AvatarItem from './AvatarItem';
import NormalField from './NormalField';

// Lodash
import _ from 'lodash';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import { Chip, ListItem } from '@material-ui/core';


const orange200 = orange['200']
const pink400 = pink['400']

const styles = {
  panelDetail: {
    width: "100%",
  },
  panelSummary: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  avatar: {
    size: 30,
    marginRight: 16,
  },
  avatarSupervisor: {
    size: 30,
    marginRight: 16,
    color: orange200,
    backgroundColor: pink400,
  },
  panelHeading: {
    fontWeight: "500",
    fontSize: 15
  },
  panelRoot: {
    marginTop: 16
  },
}

class NPUCECard extends Component {
  render() {

    let nextRetestDate = new Date(Date.parse(this.props.npuc.negativePressureUnit.nextRetestDate)).toDateString();

    (nextRetestDate === "Invalid Date") ? nextRetestDate = "N/A" : null;

    return (
      <div className="NPUCECard">
        <div>
          <NormalField
            label="Negative Pressure Unit Serial"
            input={(this.props.npuc.negativePressureUnit.serial == null) ? "N/A" : this.props.npuc.negativePressureUnit.serial} />

          <NormalField
            label="AM Reading"
            input={(this.props.npuc.amReading == null) ? "N/A" : this.props.npuc.amReading} />

          <NormalField
            label="PM Reading"
            input={(this.props.npuc.pmReading == null) ? "N/A" : this.props.npuc.pmReading} />

          <NormalField
            label="Next Retest Date"
            input={nextRetestDate} />
        </div>
      </div>
    );
  }
}

class QuestionGroup extends Component {
  render() {
    const questionsSorted = _.orderBy(this.props.questionGroup.questions, ['position']);
    const questionsList = questionsSorted.map((question, id) =>
      <Question question={question} key={id} />
    );

    let questionGroupHeader = null;
    switch (this.props.questionGroup.section) {
      case "SDQ":
        questionGroupHeader = "Site Diary Questions";
        break;
      case "RISK":
        questionGroupHeader = "Take 30 Risk assesment";
        break;
      default:
        questionGroupHeader = "Question Group";
    }

    return (
      <div className="QuestionGroup">
        <ListSubheader>{questionGroupHeader}</ListSubheader>
        <div>
          {questionsList}
        </div>
      </div>
    );
  }
}

class DailyEntry extends Component {
  render() {

    const { classes } = this.props;

    const operativesList = this.props.dailyEntry.operatives.map((operative, id) =>
      <AvatarItem object={operative} type="user" key={id} />
    );
    const questionGroups = this.props.dailyEntry.questionGroups.map((questionGroup, id) =>
      <QuestionGroup questionGroup={questionGroup} key={id} />
    );
    const NPUChecksList = this.props.dailyEntry.negativePressureUnitChecks.map((NPUCheck, id) =>
      <NPUCECard npuc={NPUCheck} key={id} />
    );
    const disabled = !this.props.dailyEntry.device.user.active

    return (
      <div className="DailyEntry">
        <ExpansionPanel elevation={0} defaultExpanded={this.props.initiallyExpanded}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}
          ><ListItem disabled={disabled}>
              <Avatar className={classes.avatarSupervisor}><IconSocialPeople /></Avatar>
              <div>
                <Typography variant='body1' style={{ marginBottom: 0 }}>{this.props.dailyEntry.device.user.fullName} </Typography>
                <Typography variant='body2' style={{ marginTop: 0 }} color='textSecondary'>{this.props.dailyEntry.device.user.role}</Typography>
                {disabled && <Chip label="Inactive" />}
              </div>
            </ListItem>


          </ExpansionPanelSummary>

          <ExpansionPanelDetails >
            <div className={classes.panelDetail}>

              <ExpansionPanel className={classes.panelRoot} defaultExpanded={this.props.initiallyExpanded}>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                >
                  <div className={classes.panelSummary}>
                    <Avatar className={classes.avatar}><IconActionQuestion /></Avatar>
                    <Typography className={classes.panelHeading}>Questions</Typography>
                  </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div>
                    {questionGroups}
                  </div>

                </ExpansionPanelDetails>
              </ExpansionPanel>



              <ExpansionPanel className={classes.panelRoot} defaultExpanded={this.props.initiallyExpanded}>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                >
                  <div className={classes.panelSummary}>
                    <Avatar className={classes.avatar} ><IconSocialPeople /></Avatar>
                    Operatives
                  </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails >
                  <List>
                    {operativesList}
                  </List>
                </ExpansionPanelDetails>
              </ExpansionPanel>


              <ExpansionPanel className={classes.panelRoot} defaultExpanded={this.props.initiallyExpanded}>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}>
                  <div className={classes.panelSummary}>
                    <Avatar className={classes.avatar} >
                      <IconActionGroupW />
                    </Avatar>
                    Negative Pressure Unit Check
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails >
                  {NPUChecksList}
                </ExpansionPanelDetails>
              </ExpansionPanel>

            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }
}

export default withStyles(styles)(DailyEntry);


// WEBPACK FOOTER //
// src/components/innerComponents/DailyEntry.js